import { render } from "./SearchWidgetCustomElement.vue?vue&type=template&id=309c4efe&scoped=true"
import script from "./SearchWidgetCustomElement.vue?vue&type=script&lang=js"
export * from "./SearchWidgetCustomElement.vue?vue&type=script&lang=js"

import "./SearchWidgetCustomElement.vue?vue&type=style&index=0&id=309c4efe&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1197528041/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309c4efe"]])

export default __exports__